import { render } from "./ReturnAccess.vue?vue&type=template&id=89bf7558&scoped=true"
import script from "./ReturnAccess.vue?vue&type=script&lang=js"
export * from "./ReturnAccess.vue?vue&type=script&lang=js"

import "./ReturnAccess.vue?vue&type=style&index=0&id=89bf7558&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bf7558"]])

export default __exports__